import { Field } from '../Field';
import SelectElement from './components/SelectElement';

export const Select = Field(SelectElement);
